import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { getHeaderOffsetPx, scrollToSection, scrollToTop } from '../utils/sectionNav';

// Keeps scroll position sane across client-side route changes: jumps to the
// top of a freshly-navigated page, or to a target section when the new
// location carries a hash (e.g. footer/nav links that send you back to
// "/#services" from a different page). The very first render is skipped —
// useSmoothScroll's own initial-load handling already covers that case.
function RouteEffects() {
  const location = useLocation();
  const hasMounted = useRef(false);

  useEffect(() => {
    if (!hasMounted.current) {
      hasMounted.current = true;
      return;
    }

    if (location.hash) {
      const sectionId = location.hash.slice(1);
      requestAnimationFrame(() => {
        scrollToSection(sectionId, { offset: getHeaderOffsetPx() });
      });
    } else {
      scrollToTop({ immediate: true });
    }
  }, [location.pathname, location.hash]);

  return null;
}

export default RouteEffects;
